import { Toaster } from "react-hot-toast";
import Router from "./routes/Router";
// Store
import { AuthContextProvider } from "./store/auth-context";

import AppConstants from "./configs/AppConstants";

import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  return (
    <div className="App">
      <GoogleOAuthProvider
        clientId={
          process.env.REACT_APP_GOOGLE_CLIENT_ID || AppConstants.CLIENT_ID
        }
      >
        <AuthContextProvider>
          <Toaster position="bottom-right" reverseOrder={true} />
          <Router />
        </AuthContextProvider>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
